import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const PhonesContent = ({data}) => {

    useEffect(() => {
        if (!data?.phonesWithMoreAttendances) return;
        const sorted = [...data.phonesWithMoreAttendances].sort((a, b) => b.qty - a.qty);

        const labelsExtended = [];
        const valuesExtended = [];

        sorted.forEach(item => {
            labelsExtended.push(ReportUtils.formatPhone(item.phone));
            valuesExtended.push(item.qty);
        });

        ReportUtils.createExportableTable(labelsExtended, valuesExtended, "Atendimentos por telefone");

        const top10 = sorted.slice(0, 10);

        const labels = [];
        const values = [];

        top10.forEach(item => {
            labels.push(ReportUtils.formatPhone(item.phone));
            values.push(item.qty);
        });

        GraphicUtils.horizontalBarChart('phones-with-more-attendances', values, labels, false);

    }, [data]);

    return (
        <>
            <div className="chart-report">
                <div className="chart-title mb-3">Atendimentos por telefone {data.phonesWithMoreAttendances.length >= 10 ? ' (TOP 10)' : ''}</div>
                <div className="chart-report bar-chart" id="phones-with-more-attendances"></div>
            </div>
        </>
    );
};

export default PhonesContent;